"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddValueContainer = void 0;
const react_1 = __importStar(require("react"));
const add_attribute_dialog_styles_1 = require("./add-attribute-dialog.styles");
const add_value_dialog_utils_1 = require("./add-value-dialog.utils");
const add_value_to_other_nodes_dialog_component_1 = require("./add-value-to-other-nodes-dialog.component");
const attribute_autocomplete_1 = require("./partials/attribute-autocomplete");
const validation_schema_1 = require("./validation-schema");
const attributes_1 = require("../../../client/attributes");
const hooks_1 = require("../../../client/hooks");
const values_1 = require("../../../client/values");
const global_tree_edit_warning_1 = require("../../../components/global-tree-edit-warning");
const context_1 = require("../../../context");
const generic_1 = require("../../../generic");
const use_attribute_values_dialog_state_hook_1 = require("../../../hooks/use-attribute-values-dialog-state.hook");
const use_history_changes_hook_1 = require("../../../hooks/use-history-changes.hook");
const hooks_2 = require("../../../../hooks");
const localization_1 = require("../../../../localization");
const localization_utils_1 = require("../../../../localization/localization.utils");
const store_1 = require("../../../../store");
const CREATE_VALUE_FORM_ID = 'create-value-form';
const getErrorMessage = (error) => {
    if (error instanceof Error) {
        return error.message;
    }
    if (typeof error === 'string') {
        return error;
    }
    return 'Unknown error';
};
const AddValueContainer = ({ selectedAttribute: defaultSelectedAttributeName, selectedStrategyNodeId, allowCreation, isReadOnly, onClose, onActionCompleted, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const { isReEnrichmentInProgress } = (0, context_1.useCatalogActivityProgressContext)();
    const { addSuccess, addError } = (0, hooks_2.useNotification)();
    const { refetchQueriesOnStrategyValueChange } = (0, hooks_1.useRefetchQueries)();
    const productTreeRootNodeId = (0, store_1.useProductTreeRootNodeId)();
    const catalogId = (0, store_1.useSelectedCatalogId)();
    const shouldShowGlobalTreeEditWarning = (0, store_1.useShouldShowGlobalTreeEditWarning)();
    const validationSchema = (0, validation_schema_1.useAttributeValidationSchema)();
    const { onGlobalTreeReplacement } = (0, global_tree_edit_warning_1.useGlobalTreeEditWarning)(selectedStrategyNodeId);
    const { addValuesToSeveralNodes } = (0, values_1.useAddValuesToSeveralNodes)();
    const { editAttributes } = (0, attributes_1.useEditAttributes)();
    const { handleAddNewItemsToHistory } = (0, use_history_changes_hook_1.useHistoryChanges)();
    const [isAddToSelectedNodeDialogOpen, setAddToSelectedNodeDialogOpen] = (0, react_1.useState)(true);
    const [addToOtherNodesDialogConfig, setAddToOtherNodesDialogConfig] = (0, react_1.useState)(null);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const { selectedAttributeName, setSelectedAttributeName, dialogInitialValues, dialogLoading, attributesOptionList, matchedValueNames, loadedValueItems, valuesLoading, valuesHasNextPage, valuesMoreItemsLoading, attributesLoading, attributesHasNextPage, attributesMoreItemsLoading, handleValuesLoadMore, handleValueSearch, handleAttributesLoadMore, handleAttributeSearch, } = (0, use_attribute_values_dialog_state_hook_1.useAttributeValuesDialogState)({
        defaultSelectedAttributeName,
        selectedStrategyNodeId,
        catalogId,
    });
    const canSelectAttribute = allowCreation && !defaultSelectedAttributeName;
    const dispatchError = (attributes, error) => {
        addError(t({
            key: 'ADD_ENTITY_ERROR',
            values: {
                count: attributes.length,
                entity: String(t({ key: 'VALUE' })).toLowerCase(),
                b: localization_utils_1.renderBoldText,
            },
        }), error);
    };
    const handleUpdateProductPresentation = (attributeName, relatedTreeNodeIds) => refetchQueriesOnStrategyValueChange({
        selectedTreeNodeId: selectedStrategyNodeId,
        attributeName,
        relatedTreeNodeIds,
    });
    const handleTreeReplacement = (isGlobalStrategyReplacementAccepted) => __awaiter(void 0, void 0, void 0, function* () {
        const isTreeReplacementNeeded = shouldShowGlobalTreeEditWarning && isGlobalStrategyReplacementAccepted;
        if (!isTreeReplacementNeeded) {
            return { rootNodeId: productTreeRootNodeId, targetNodeId: selectedStrategyNodeId };
        }
        const metadata = yield onGlobalTreeReplacement();
        if (!metadata.targetNodeId) {
            throw new Error('Target node is not found');
        }
        return metadata;
    });
    const handleAddValuesToSelectedNode = (_a) => __awaiter(void 0, [_a], void 0, function* ({ attributes, isGlobalStrategyReplacementAccepted }) {
        const parsedAttributeData = (0, add_value_dialog_utils_1.parseFormValues)(attributes[0]);
        const { valuesWithNewGuideline = [], isDescriptionChanged, newValues = [] } = parsedAttributeData, attribute = __rest(parsedAttributeData, ["valuesWithNewGuideline", "isDescriptionChanged", "newValues"]);
        try {
            const { targetNodeId, rootNodeId } = yield handleTreeReplacement(isGlobalStrategyReplacementAccepted);
            const newData = [Object.assign(Object.assign({}, attribute), { values: newValues })];
            const promises = [];
            if (newValues === null || newValues === void 0 ? void 0 : newValues.length) {
                promises.push(addValuesToSeveralNodes(newData, [targetNodeId])
                    .then((updatedTreeNodePaths) => handleAddNewItemsToHistory(parsedAttributeData, updatedTreeNodePaths)));
            }
            if ((valuesWithNewGuideline === null || valuesWithNewGuideline === void 0 ? void 0 : valuesWithNewGuideline.length) || isDescriptionChanged) {
                promises.push(editAttributes([Object.assign(Object.assign({}, attribute), { values: valuesWithNewGuideline })], [rootNodeId]));
            }
            const responses = yield Promise.allSettled(promises);
            for (const response of responses) {
                if (response.status === 'rejected') {
                    throw new Error(getErrorMessage(response.reason));
                }
            }
            if (newValues === null || newValues === void 0 ? void 0 : newValues.length) {
                setAddToSelectedNodeDialogOpen(false);
                setAddToOtherNodesDialogConfig(newData);
                void handleUpdateProductPresentation(attribute.name);
            }
            else {
                addSuccess(t({ key: 'EDIT_GUIDELINES_SUCCESS', values: { entityName: attribute.name } }));
                onClose();
            }
        }
        catch (error) {
            dispatchError(attributes, getErrorMessage(error));
        }
    });
    const handleAddValuesToOtherNodes = (selectedNodeIds) => __awaiter(void 0, void 0, void 0, function* () {
        setIsLoading(true);
        const _a = addToOtherNodesDialogConfig[0], { values } = _a, item = __rest(_a, ["values"]);
        const { name: attributeName } = item;
        try {
            const updatedTreeNodePaths = yield addValuesToSeveralNodes(addToOtherNodesDialogConfig, selectedNodeIds);
            handleAddNewItemsToHistory(Object.assign(Object.assign({}, item), { newValues: values }), updatedTreeNodePaths);
            const entities = values.map(({ name }) => name).join(', ');
            addSuccess(t({
                key: 'ADD_ENTITY_TO_OTHER_NODES_SUCCESS',
                values: {
                    count: addToOtherNodesDialogConfig.length,
                    entity: String(t({ key: 'VALUE' })).toLowerCase(),
                    entityName: entities,
                },
            }));
            onActionCompleted(() => handleUpdateProductPresentation(attributeName, selectedNodeIds));
        }
        catch (error) {
            dispatchError(addToOtherNodesDialogConfig, getErrorMessage(error));
        }
        finally {
            setIsLoading(false);
            setAddToOtherNodesDialogConfig(null);
            onClose();
        }
    });
    const handleAddToOtherNodesDialogClose = () => {
        const { name } = addToOtherNodesDialogConfig[0];
        setAddToOtherNodesDialogConfig(null);
        onActionCompleted(() => handleUpdateProductPresentation(name));
        onClose();
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, isAddToSelectedNodeDialogOpen && (react_1.default.createElement(generic_1.CreateEntityDialog, { allowCreation: allowCreation, isReadOnly: isReadOnly || isReEnrichmentInProgress, initialValues: dialogInitialValues, validationSchema: validationSchema, title: allowCreation
            ? (() => {
                const titleText = t({
                    key: 'ADD_ENTITY_TO_ENTITY',
                    values: {
                        entity: String(t({ key: 'VALUES' })).toLowerCase(),
                        targetEntity: String(t({ key: 'ATTRIBUTE' })).toLowerCase(),
                    },
                });
                return (react_1.default.createElement(add_attribute_dialog_styles_1.StyledCreateEntityDialogTitle, { className: "create-entity-dialog-title" }, react_1.default.createElement("div", { className: "create-entity-dialog-title-text" }, titleText), canSelectAttribute && !isReadOnly && !isReEnrichmentInProgress && (react_1.default.createElement(attribute_autocomplete_1.AttributeAutocomplete, { className: "create-entity-dialog-title-action", options: attributesOptionList, selected: selectedAttributeName, allowCreation: false, isLoading: attributesLoading, moreItemsLoading: attributesMoreItemsLoading, hasNextPage: attributesHasNextPage, onLoadMore: handleAttributesLoadMore, onSearch: handleAttributeSearch, onSelect: setSelectedAttributeName }))));
            })()
            : t({ key: 'GUIDELINE_DIALOG_TITLE' }), formId: CREATE_VALUE_FORM_ID, attributesOptionList: attributesOptionList, isLoading: dialogLoading, valueOptionListStrategyNodeId: productTreeRootNodeId, selectedStrategyNodeId: selectedStrategyNodeId, matchedValueNames: matchedValueNames, loadedValueItems: loadedValueItems, valuesLoading: valuesLoading, valuesHasNextPage: valuesHasNextPage, valuesMoreItemsLoading: valuesMoreItemsLoading, valueSectionLabels: {
            added: t({ key: 'VALUE_LIST_SECTION_ADDED' }),
            existing: t({ key: 'VALUE_LIST_SECTION_EXISTING' }),
        }, onValuesLoadMore: handleValuesLoadMore, onSubmit: handleAddValuesToSelectedNode, onClose: onClose, onValueSearch: handleValueSearch })), !!addToOtherNodesDialogConfig && (react_1.default.createElement(add_value_to_other_nodes_dialog_component_1.AddValueToOtherNodesDialog, { onClose: handleAddToOtherNodesDialogClose, onSubmit: handleAddValuesToOtherNodes, attributes: addToOtherNodesDialogConfig, isLoading: isLoading }))));
};
exports.AddValueContainer = AddValueContainer;
exports.default = exports.AddValueContainer;
